import { useTranslation } from "react-i18next";
import Select from "../common/components/Select"
import { realizeMapZones, useMapZones } from "../reducers/mapZoneSlice"

export const customCtrlDef = {
    toString: async ({ value, defaultValue, ...props }) => {
        if (!value) {
            return defaultValue;
        }
        let zones = await realizeMapZones({ ...props });
        return zones.find(z => z.name == value)?.name ?? value;
    },
    control: ({ value, def, ...props }) => <ZoneDropdown value={value} placeholder={def.placeholder} wildcard={def.wildcard} {...props}></ZoneDropdown>
}

const ZoneDropdown = ({ placeholder, ...props }) => {
    const { t } = useTranslation();
    const zones = useMapZones();
    return <Select placeholder={placeholder ?? t('zone', { count: 1 })} options={zones} labelField="name" valueField="name" {...props}></Select>
}

export default ZoneDropdown;